__turbopack_context__.v({
  "body": "RegisterWatch-module-scss-module__L9LSaa__body",
  "container": "RegisterWatch-module-scss-module__L9LSaa__container",
  "content": "RegisterWatch-module-scss-module__L9LSaa__content",
  "contentPanel": "RegisterWatch-module-scss-module__L9LSaa__contentPanel",
  "cta": "RegisterWatch-module-scss-module__L9LSaa__cta",
  "header": "RegisterWatch-module-scss-module__L9LSaa__header",
  "icon": "RegisterWatch-module-scss-module__L9LSaa__icon",
  "iconFallback": "RegisterWatch-module-scss-module__L9LSaa__iconFallback",
  "iconWrapper": "RegisterWatch-module-scss-module__L9LSaa__iconWrapper",
  "image": "RegisterWatch-module-scss-module__L9LSaa__image",
  "imagePanel": "RegisterWatch-module-scss-module__L9LSaa__imagePanel",
  "section": "RegisterWatch-module-scss-module__L9LSaa__section",
  "subtitle": "RegisterWatch-module-scss-module__L9LSaa__subtitle",
  "title": "RegisterWatch-module-scss-module__L9LSaa__title",
  "titleAccent": "RegisterWatch-module-scss-module__L9LSaa__titleAccent",
});
